import { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { Coder } from 'abi-coder'

import WrappedInput from 'src/ui/atoms/Input/Wrapped'
import Button from 'src/ui/atoms/Button'
import { formatWordCapitalized } from 'src/util/formats'
import useProjectsApi, { IProject } from '../../useProjectApi'

const WriteForm = ({ selectedAction, project }: { selectedAction: any; project: IProject }) => {
  const [isLoading, setLoading] = useState<boolean>(false)
  const [inputErrors, setInputErrors] = useState<any>(null)

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
  })
  const { executeAction } = useProjectsApi()
  const erc20Coder = project.abi?.length ? new Coder(project.abi) : null

  const decimals =
    project?.data?.numberOfDecimals ||
    parseInt(project?.data?.stakedTokenAddressDetails?.decimals || '0') ||
    parseInt(project?.data?.vestedTokenAddressDetails?.decimals || '0')

  useEffect(() => {
    reset()
  }, [selectedAction])

  const handleExecute = async (inputData: any) => {
    try {
      setLoading(true)
      setInputErrors(null)

      let formattedData = inputData
      for (const input of selectedAction.inputs) {
        if (input.name === '_expiry') {
          formattedData[input.name] = BigInt(inputData[input.name])
        } else if (input.name !== '_expiry' && input.type === 'uint256') {
          formattedData[input.name] = BigInt(inputData[input.name]) * BigInt(10 ** decimals)
        }
      }

      const data = erc20Coder?.encodeFunction(selectedAction.name, formattedData) as string
      await executeAction({ data, project })
      setLoading(false)
    } catch (e: any) {
      setLoading(false)
      e.shortMessage ? console.error(e.shortMessage) : console.error(e)
      e.argument &&
        setInputErrors({
          ...inputErrors,
          [e.argument]: e.argument,
        })
    }
  }

  if (!selectedAction || selectedAction.constant) {
    return null
  }

  if (selectedAction.inputs?.length) {
    return (
      <form className="grid w-full gap-4" onSubmit={handleSubmit((data) => handleExecute(data))}>
        {selectedAction.inputs?.map((input: any, index: number) => (
          <WrappedInput
            key={index}
            label={formatWordCapitalized(input.name[0] === '_' ? input.name.slice(1) : input.name)}
            placeholder={input.type}
            type={input.type === 'uint256' ? 'number' : 'text'}
            error={
              (inputErrors?.[input.name] && { message: 'Invalid value' }) ||
              errors[input.name] ||
              false
            }
            {...register(input.name, {
              required: 'Required field',
            })}
          />
        ))}
        <div className="flex flex-col">
          <Button
            name="Execute"
            className="mt-4 self-end"
            loading={isLoading}
            disabled={!isValid}
          />
        </div>
      </form>
    )
  } else {
    return (
      <Button
        name="Execute"
        className="mt-4 self-end"
        loading={isLoading}
        disabled={!isValid}
        onClick={handleExecute}
      />
    )
  }
}

export default WriteForm
